import { render, staticRenderFns } from "./TbbAside.vue?vue&type=template&id=6795071a&scoped=true"
import script from "./TbbAside.vue?vue&type=script&lang=js"
export * from "./TbbAside.vue?vue&type=script&lang=js"
import style0 from "./TbbAside.vue?vue&type=style&index=0&id=6795071a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6795071a",
  null
  
)

export default component.exports